var _ = require('lodash');

var isGoalActive = function(editor, goal) {
  return _.any(editor.pages, function(page) {
    return page.goals.isGoalActive(goal);
  });
};

var extractUniqueGoals = function(allGoals) {
  return allGoals.flatten()
    .uniq('url')
    .value();
};

var getAllGoals = function(editor) {
  var allGoals = _(editor.pages).map(function(page) {
    return page.goals.getGoals();
  });
  return extractUniqueGoals(allGoals);
};

var getAllActiveGoals = function(editor) {
  var allGoals = _(editor.pages).map(function(page) {
    return page.goals.getActiveGoals();
  });
  return extractUniqueGoals(allGoals);
};

var stripTrailingSlash = function(url) {
  if (url.substr(-1) === '/') {
    return url.substr(0, url.length - 1);
  }
  return url;
};

var syncActiveGoals = function(allGoals, allActiveGoals) {
  return _(allActiveGoals)
    .filter(function(activeGoal) {
      var matchingPossibleGoal = _.find(allGoals, function(possibleGoal) {
        // Because the goal object can be polluted with other properties, we should only
        // sync and filter the active goals by comparing the two properties that matter: "type" and "url"
        return (activeGoal.type === possibleGoal.type) &&
          (stripTrailingSlash(activeGoal.url) === stripTrailingSlash(possibleGoal.url));
      });

      return Boolean(matchingPossibleGoal);
    })
    .value();
};

var updateAndSyncGoals = function(editor) {
  var allGoals = getAllGoals(editor);
  var allActiveGoals = getAllActiveGoals(editor);
  var newActiveGoals = syncActiveGoals(allGoals, allActiveGoals);

  _.each(editor.pages, function(page) {
    if ( ! page.isFormConfirmation()) {
      page.settings.activeGoals = newActiveGoals;
    }
  });

};

var addActiveGoalForAllPages = function(editor, g, activateGoal) {
  editor.pages
    .filter(function(page) {
      // We don't add active goals to form confirmation dialog
      return ! page.isFormConfirmation();
    })
    .forEach(function(page) {
      var goals = page.goals;

      if (activateGoal) {
        goals.addActiveGoal(g);
      } else {
        goals.removeActiveGoal(g);
      }
    });
};

const sortOrderMap = {
  download: 0,
  form: 1,
  link: 2,
  phone: 3,
  lightbox: 4
};

const addSortOrder = (goals) => {
  return  _.map(goals, (goal) => _.assign(goal, {sortOrder: sortOrderMap[goal.type] || 0}));
};

const getElmGoal = (elm) => {
  // Goals do not initally have a sort order value. This adds a 'sortOrder' property that we use to sort the goals later
    return addSortOrder(elm.getGoals());
};

var isConvertable = function(editor) {
  return editor.page.settings.contentType === 'embeddable' || editor.page.settings.contentType === 'stickyBar'; 
};

var shouldAutoEnableGoal = function(editor, elm) {
  var initialUrl = elm.model.jso.action.url;
  var hasActiveGoal = isGoalActive(editor, getElmGoal(elm)[0]);
  return (initialUrl === "" || hasActiveGoal) && isConvertable(editor);
};

module.exports = {
  isGoalActive,
  updateAndSyncGoals,
  addActiveGoalForAllPages,
  getAllActiveGoals,
  getAllGoals,
  syncActiveGoals,
  addSortOrder,
  getElmGoal,
  isConvertable,
  shouldAutoEnableGoal,
  extractUniqueGoals,
  stripTrailingSlash,
};



// WEBPACK FOOTER //
// ./src/lp/editor/goals.js